export enum MessageTypes  {
    Comment = 0,
    Mail = 1,
    SMS = 2,
    Whatsapp = 3
}